<template lang="pug">
section.main(:class="collapsed ? 'wide' : 'narrow'")
  Header(ref="header")
  Menu
  section.page.dashboard(v-if="$auth.isAuthenticated && currentUser")
    h1.title
      i.icon.fas.fa-tachometer-alt
      span {{ page.title }}

    section.body
      b-navbar
        b-navbar-nav
          b-nav-form.filters(inline)
            b-input-group(size="sm")
              b-form-select(size="sm",v-model="filters.job",:options="options.job",@change="reloadData")

        b-navbar-nav.ml-auto
          b-button.ml-2(size="sm",variant="link",@click="reloadData")
            i.fas.fa-sync-alt

      b-tabs(v-model="select",pills)
        b-tab(title="採用コンディション")
        b-tab(title="ボリューム")
        b-tab(title="クオリティ")
        b-tab(title="スピード")

      .d-flex.flex-row
        section.left.d-flex.align-items-stretch
          b-card.p-0.w-100(body-class="p-0")
            b-card-header.p-0
              b-jumbotron.condition.rounded-0.p-0.m-0.clickable(:class="datum.condition",@click="select=0")
                .text-center.pt-4.pb-2
                  b-spinner.preloader(v-if="!datum.condition")
                  h2(v-else)
                    i.icon(:class="getConditionIcon()")
                .text-center.pt-2.pb-3
                  h3.caption {{ getConditionTitle() }}
                  p.description(v-html="getConditionDescription()")

            b-list-group(flush)
              b-list-group-item.volume.p-0
                b-card.clickable(body-class="p-0",@click="select=1")
                  b-card-header.px-3.d-flex.justify-content-between.align-items-center
                    h4.h5.m-0
                      i.icon.fas.fa-users
                      span.ml-2 ボリューム
                    small.sticky
                      span.mr-2 目標値 {{ formatPoint(3) }}
                      a
                        i.icon.fas.fa-angle-right
                  b-list-group(flush)
                    b-list-group-item.p-3(class="d-flex justify-content-between align-items-center")
                      span 書類選考通過者数
                        b-badge.ml-2(variant="light") 月間
                      span.score {{ score && score.volume && score.volume.pass && score.volume.pass.currentCount !== null ? score.volume.pass.currentCount : '-' }}人
                  b-list-group(flush)
                    b-list-group-item.p-3(class="d-flex justify-content-between align-items-center")
                      span 選考中の候補者数
                        b-badge.ml-2(variant="light") 現在
                      span.score {{ score && score.volume && score.volume.under && score.volume.under.count !== null ? score.volume.under.count : '-' }}人
              b-list-group-item.quality.p-0
                b-card.clickable(body-class="p-0",@click="select=2")
                  b-card-header.px-3.d-flex.justify-content-between.align-items-center
                    h4.h5.m-0
                      i.icon.fas.fa-thumbs-up
                      span.ml-2 クオリティ
                    small.sticky
                      span.mr-2 目標値 {{ formatPoint(3) }}
                      a
                        i.icon.fas.fa-angle-right
                  b-list-group(flush)
                    b-list-group-item.p-3(class="d-flex justify-content-between align-items-center")
                      span 一次選考通過率
                        b-badge.ml-2(variant="light") 通算
                      span.score {{ score && score.quality && score.quality.pass && score.quality.pass.rate !== null ? Math.floor(score.quality.pass.rate * 100) : '-' }}%
                  b-list-group(flush)
                    b-list-group-item.p-3(class="d-flex justify-content-between align-items-center")
                      span 入社決定率
                        b-badge.ml-2(variant="light") 通算
                      span.score {{ score && score.quality && score.quality.employ && score.quality.employ.rate !== null ? Math.floor(score.quality.employ.rate * 100) : '-' }}%
              b-list-group-item.speed.p-0
                b-card.clickable(body-class="p-0",@click="select=3")
                  b-card-header.px-3.d-flex.justify-content-between.align-items-center
                    h4.h5.m-0
                      i.icon.fas.fa-road
                      span.ml-2 スピード
                    small.sticky
                      span.mr-2 目標値 {{ formatPoint(3) }}
                      a
                        i.icon.fas.fa-angle-right
                  b-list-group(flush)
                    b-list-group-item.p-3(class="d-flex justify-content-between align-items-center")
                      span 書類選考日数
                        b-badge.ml-2(variant="light") 通算
                      span.score {{ score && score.speed && score.speed.screen && score.speed.screen.count > 0 ? formatNumber(score.speed.screen.average) : '-' }}日
                    b-list-group-item.p-3(class="d-flex justify-content-between align-items-center")
                      span 一次選考調整日数
                        b-badge.ml-2(variant="light") 通算
                      span.score {{ score && score.speed && score.speed.adjust && score.speed.adjust.count > 0 ? formatNumber(score.speed.adjust.average) : '-' }}日

        section.right.py-5
          template(v-if="mode === 'whole'")
            .chart.w-75.my-5
              .wrapper.text-center
                i.icon.volume.fas.fa-users
                i.icon.quality.fas.fa-thumbs-up
                i.icon.speed.fas.fa-road

                span.value.volume {{ score && score.volume && score.volume.score ? formatPoint(score.volume.score) : '' }}
                span.value.quality {{ score && score.quality && score.quality.score ? formatPoint(score.quality.score) : '' }}
                span.value.speed {{ score && score.speed && score.speed.score ? formatPoint(score.speed.score) : '' }}

                svg(ref="chart",width="400",height="410",viewBox="0 0 400 410")
                  g
                    circle.circle0(:cx="400 / 2 + 1",:cy="400 / 2 + 1 + 10",:r="400 / 2 - 2")
                    circle.circle1(:cx="400 / 2 + 1",:cy="400 / 2 + 1 + 10",:r="400 * (5 / 6) / 2 - 2")
                    circle.circle2(:cx="400 / 2 + 1",:cy="400 / 2 + 1 + 10",:r="400 * (4 / 6) / 2 - 2")
                    circle.circle3(:cx="400 / 2 + 1",:cy="400 / 2 + 1 + 10",:r="400 * (5 / 6) / 2 - 2")
                    circle.circle4(:cx="400 / 2 + 1",:cy="400 / 2 + 1 + 10",:r="400 * (3 / 6) / 2 - 2")
                    circle.circle5(:cx="400 / 2 + 1",:cy="400 / 2 + 1 + 10",:r="400 * (2 / 6) / 2 - 2")
                    circle.circle6(:cx="400 / 2 + 1",:cy="400 / 2 + 1 + 10",:r="400 * (1 / 6) / 2 - 2")
                    line(x1="200",:y1="0 + 10",x2="200",:y2="200 + 10")
                    line(x1="200",:y1="200 + 10",x2="371.5",:y2="299 + 10")
                    line(x1="200",:y1="200 + 10",x2="28.5",:y2="299 + 10")
                  g(v-if="points && points.volume && points.quality && points.speed")
                   polygon(:points="`${points.quality.x},${points.quality.y + 10} ${points.volume.x},${points.volume.y + 10} ${points.speed.x},${points.speed.y + 10}`")
                   circle.values.volume(:cx="points.volume.x",:cy="points.volume.y + 10",r="10")
                   circle.values.quality(:cx="points.quality.x",:cy="points.quality.y + 10",r="10")
                   circle.values.speed(:cx="points.speed.x",:cy="points.speed.y + 10",r="10")

            .legends.d-flex.flex-wrap.justify-content-center.text-center
              .volume.mr-3
                span.caption.mr-2 ボリューム
                span.score {{ score && score.volume && score.volume.score ? formatPoint(score.volume.score) : '-' }}
              .quality.mr-3
                span.caption.mr-2 クオリティ
                span.score {{ score && score.quality && score.quality.score ? formatPoint(score.quality.score) : '-' }}
              .speed
                span.caption.mr-2 スピード
                span.score {{ score && score.speed && score.speed.score ? formatPoint(score.speed.score) : '-' }}

            b-alert.calculating(v-if="!datum || !datum.condition",show,variant="danger")
              span 採用コンディションはただいま集計中です。<br>概ね利用開始から1ヶ月程度で算出されます。

          template(v-if="mode === 'volume' || mode === 'quality' || mode === 'speed'")
            h2.d-flex.justify-content-between.align-items-center(:class="mode")
              template(v-if="mode === 'volume'")
                .title
                  i.icon.fas.fa-users
                  span.ml-2 ボリューム
                small.sticky
                  span.caption.mr-2 総スコア
                  span.score {{ score && score.volume && score.volume.score ? formatPoint(score.volume.score) : '-' }}
              template(v-if="mode === 'quality'")
                .title
                  i.icon.fas.fa-thumbs-up
                  span.ml-2 クオリティ
                small.sticky
                  span.caption.mr-2 総スコア
                  span.score {{ score && score.quality && score.quality.score ? formatPoint(score.quality.score) : '-' }}
              template(v-if="mode === 'speed'")
                .title
                  i.icon.fas.fa-road
                  span.ml-2 スピード
                small.sticky
                  span.caption.mr-2 総スコア
                  span.score {{ score && score.speed && score.speed.score ? formatPoint(score.speed.score) : '-' }}

          template(v-if="mode === 'volume'")
            p.note.my-5.mx-5 採用活動における「ボリューム（選考者数）」のコンディションです。<br>
              | 通算の書類選考通過者数と現在選考中の候補者数で算出され、「3」が目標値となります。
            b-card.my-3.mx-5(no-body)
              b-card-body
                .d-flex.justify-content-between.align-items-center
                  h3 書類選考通過者数
                    b-badge(variant="light").ml-3 月間
                  .values.d-flex
                    .score.mr-5
                      span.caption.mr-2 スコア
                      span.value {{ score && score.volume && score.volume.pass && score.volume.pass.score ? formatPoint(score.volume.pass.score) : '-' }}
                    .precentage
                      span.value.h2 {{ score && score.volume && score.volume.pass && score.volume.pass.currentCount !== null ? score.volume.pass.currentCount : '-' }}
                      span.unit.ml-2 人
            b-card.my-3.mx-5(no-body)
              b-card-body
                .d-flex.justify-content-between.align-items-center
                  h3 選考中の候補者数
                    b-badge(variant="light").ml-3 現在
                  .values.d-flex
                    .score.mr-5
                      span.caption.mr-2 スコア
                      span.value {{ score && score.volume && score.volume.under && score.volume.under.score ? formatPoint(score.volume.under.score) : '-' }}
                    .precentage
                      span.value.h2 {{ score && score.volume && score.volume.under && score.volume.under.count !== null ? score.volume.under.count : '-' }}
                      span.unit.ml-2 人

          template(v-if="mode === 'quality'")
            p.note.my-5.mx-5 採用活動における「クオリティ（選考通過率）」のコンディションです。<br>
              | 一次選考通過率と入社決定率で算出され、「3」が目標値となります。
            b-card.my-3.mx-5(no-body)
              b-card-body.pb-1
                b-row.pb-4
                  b-col
                    .d-flex.justify-content-between.align-items-center
                      h3 一次選考通過率
                        b-badge(variant="light").ml-3 通算
                      .values.d-flex
                        .score.mr-5
                          span.caption.mr-2 スコア
                          span.value {{ score && score.quality && score.quality.pass && score.quality.pass.score ? formatPoint(score.quality.pass.score) : '-' }}
                        .precentage
                          span.value.h2 {{ score && score.quality && score.quality.pass && score.quality.pass.rate !== null ? Math.floor(score.quality.pass.rate * 100) : '-' }}
                          span.unit.ml-2 %
                b-row.pt-3.pb-2.border-top
                  b-col.border-right
                    .d-flex.justify-content-between.align-items-center
                      span.caption 一次選考通過者数
                      .values.d-flex
                        span.value {{ score && score.quality && score.quality.pass && score.quality.pass.count ? score.quality.pass.count : '-' }}
                        span.unit 人
                  b-col
                    .d-flex.justify-content-between.align-items-center
                      span.caption 一次選考実施者数
                      .values.d-flex
                        span.value {{ score && score.quality && score.quality.screen && score.quality.screen.count ? score.quality.screen.count : '-' }}
                        span.unit 人
            b-card.my-3.mx-5(no-body)
              b-card-body.pb-1
                b-row.pb-4
                  b-col
                    .d-flex.justify-content-between.align-items-center
                      h3 入社決定率
                        b-badge(variant="light").ml-3 通算
                      .values.d-flex
                        .score.mr-5
                          span.caption.mr-2 スコア
                          span.value {{ score && score.quality && score.quality.employ && score.quality.employ.score ? formatPoint(score.quality.employ.score) : '-' }}
                        .precentage
                          span.value.h2 {{ score && score.quality && score.quality.employ && score.quality.employ.rate !== null ? Math.floor(score.quality.employ.rate * 100) : '-' }}
                          span.unit.ml-2 %
                b-row.pt-3.pb-2.border-top
                  b-col.border-right
                    .d-flex.justify-content-between.align-items-center
                      span.caption 入社決定数
                      .values.d-flex
                        span.value {{ score && score.quality && score.quality.employ && score.quality.employ.count ? score.quality.employ.count : '-' }}
                        span.unit 人
                  b-col
                    .d-flex.justify-content-between.align-items-center
                      span.caption 一次選考実施者数
                      .values.d-flex
                        span.value {{ score && score.quality && score.quality.screen && score.quality.screen.count ? score.quality.screen.count : '-' }}
                        span.unit 人

          template(v-if="mode === 'speed'")
            p.note.my-5.mx-5 採用活動における「スピード（選考日数）」のコンディションです。<br>
              | 書類選考日数と一次選考調整日数で算出され、「3」が目標値となります。
            b-card.my-3.mx-5(no-body)
              b-card-body
                .d-flex.justify-content-between.align-items-center
                  h3 書類選考日数
                    b-badge(variant="light").ml-3 通算
                  .values.d-flex
                    .score.mr-5
                      span.caption.mr-2 スコア
                      span.value {{ score && score.speed && score.speed.screen && score.speed.screen.score ? formatPoint(score.speed.screen.score) : '-' }}
                    .precentage
                      span.value.h2 {{ score && score.speed && score.speed.screen && score.speed.screen.count > 0 ? formatNumber(score.speed.screen.average) : '-' }}
                      span.unit.ml-2 日
            b-card.my-3.mx-5(no-body)
              b-card-body
                .d-flex.justify-content-between.align-items-center
                  h3 一次選考調整日数
                    b-badge(variant="light").ml-3 通算
                  .values.d-flex
                    .score.mr-5
                      span.caption.mr-2 スコア
                      span.value {{ score && score.speed && score.speed.adjust && score.speed.adjust.score ? formatPoint(score.speed.adjust.score) : '-' }}
                    .precentage
                      span.value.h2 {{ score && score.speed && score.speed.adjust && score.speed.adjust.count > 0 ? formatNumber(score.speed.adjust.average) : '-' }}
                      span.unit.ml-2 日
</template>

<script>
import QueryHash from 'query-hash'

import { getData } from '../utils/api'

import { clone, getCondition } from '../utils/libs'

import 'dayjs/locale/ja'
import dayjs from 'dayjs'
import localizedFormat from 'dayjs/plugin/localizedFormat'

dayjs.locale('ja')
dayjs.extend(localizedFormat)

const page = {
  id: 'dashboard',
  title: 'ダッシュボード'
}

export default {
  name: page.id,
  data () {
    return {
      mask: false,
      app: {
        name: process.env.VUE_APP_NAME
      },
      page: page,
      currentUser: null,
      collapsed: true,
      select: 0,
      mode: 'whole',
      // data: [],
      filters: {},
      options: {
        job: []
      },
      datum: {
        condition: null,
        score: {
          volume: {
            pass: {
              score: null,
              rate: null
            },
            under: {
              score: null,
              rate: null
            }
          },
          quality: {
            pass: {
              score: null,
              rate: null
            },
            employ: {
              score: null,
              rate: null
            }
          },
          speed: {
            screen: {
              score: null,
              number: null
            },
            adjust: {
              score: null,
              number: null
            }
          }
        }
      },
      score: null,
      condition: null,
      points: {}
    }
  },
  watch: {
    select (val) {
      if (val === 0) {
        this.mode = 'whole'
      } else if (val === 1) {
        this.mode = 'volume'
      } else if (val === 2) {
        this.mode = 'quality'
      } else if (val === 3) {
        this.mode = 'speed'
      }

      if (val === 0) {
        this.handleLink(`/${this.$route.params.directory}/?`)
      } else {
        this.handleLink(`/${this.$route.params.directory}/?${this.mode}`)
      }
    },
    'filters.job' (val) {
      this.reloadData()
    }
  },
  mounted () {
    this.mode = 'whole'

    if (this.$route.query.volume !== undefined) {
      this.mode = 'volume'
      this.select = 1
    } else if (this.$route.query.quality !== undefined) {
      this.mode = 'quality'
      this.select = 2
    } else if (this.$route.query.speed !== undefined) {
      this.mode = 'speed'
      this.select = 3
    }
  },
  methods: {
    getConditionIcon () {
      return this.condition && this.condition.icon ? this.condition.icon : ''
    },
    getConditionTitle () {
      return this.condition && this.condition.title ? this.condition.title : ''
    },
    getConditionDescription () {
      let description = this.condition && this.condition.description ? this.condition.description : ''

      let segment = '-'

      if (description.indexOf('%%segment%%') >= 0) {
        let arr = []

        arr.push({ 'volume': this.datum.score.volume && this.datum.score.volume.score ? this.datum.score.volume.score : 0 })
        arr.push({ 'quality': this.datum.score.quality && this.datum.score.quality.score ? this.datum.score.quality.score : 0 })
        arr.push({ 'speed': this.datum.score.speed && this.datum.score.speed.score ? this.datum.score.speed.score : 0 })

        arr.sort((a, b) => {
          const _a = a[Object.keys(a)]
          const _b = b[Object.keys(b)]
          if (_a < _b) {
            return -1
          } else if (_a > _b) {
            return 1
          } else {
            return 0
          }
        })

        const minScoreKey = Object.keys(arr[0])[0]
        if (minScoreKey === 'volume') {
          segment = 'ボリューム（候補者数）'
        } else if (minScoreKey === 'quality') {
          segment = 'クオリティ（選考通過率）'
        } else if (minScoreKey === 'speed') {
          segment = 'スピード（選考日数）'
        }
      }

      description = description.replace(/%%segment%%/g, `「${segment}」`)

      return description
    },
    formatPoint (val) {
      return new Intl.NumberFormat('ja', { minimumFractionDigits: 1 }).format(val)
    },
    formatNumber (val) {
      return new Intl.NumberFormat('ja', { maximumFractionDigits: 1 }).format(val)
    },
    valueToPoint (value, index) {
      const total = 3
      let x = 0
      let y = -value * 66
      let angle = ((Math.PI * 2) / total) * index
      let cos = Math.cos(angle)
      let sin = Math.sin(angle)
      let tx = x * cos - y * sin + 200
      let ty = x * sin + y * cos + 200
      return { x: tx, y: ty }
    },
    async prepareData () {
      this.mask = true

      if (!this.$root.currentUser || !this.$root.currentUser.role) {
        setTimeout(() => {
          this.prepareData()
        }, 300)
        return
      }

      if (this.$root.currentUser.role === 'agent') {
        this.handleLink(`/${this.$route.params.directory}/peoples`)
        return
      }

      this.$set(this, 'currentUser', this.$root.currentUser)

      this.filters.job = null

      this.options.job = [{
        value: null, text: 'すべてのポジション'
      }]

      await getData(`/jobs?sort=occupation,position&limit=-1`).then((data) => {
        for (let datum of data) {
          this.options.job.push({
            value: datum._id, text: datum.name
          })
        }
      }).catch((err) => {
        console.log(err)
      })

      this.reloadData()
    },
    async reloadData () {
      this.mask = true

      this.loadData()
    },
    async loadData () {
      this.mask = true

      let query = new QueryHash()

      let filters = []
      if (this.filters.job) {
        filters.push({ jobId: `ObjectId:('${this.filters.job}')` })
        filters.push({ peopleId: { $exists: false } })
      } else {
        filters.push({ jobId: { $exists: false } })
        filters.push({ peopleId: { $exists: false } })
      }
      if (filters.length > 0) {
        query.add('filter', JSON.stringify({ $and: filters }))
      }

      query.add('sort', '-computedAt')
      query.add('limit', 1)

      this.datum = {
        condition: null,
        score: {
          volume: {
            score: null,
            pass: {
              score: null,
              rate: null
            },
            under: {
              score: null,
              rate: null
            }
          },
          quality: {
            score: null,
            pass: {
              score: null,
              rate: null
            },
            employ: {
              score: null,
              rate: null
            }
          },
          speed: {
            score: null,
            screen: {
              score: null,
              number: null
            },
            adjust: {
              score: null,
              number: null
            }
          }
        }
      }

      this.condition = null
      this.score = null
      this.points = {
        volume: 0,
        quality: 0,
        speed: 0
      }

      if (this.currentUser.role !== 'agent') {
        await getData(`/conditions?${query.toQueryString()}`).then((data) => {
          if (data && data.length > 0) {
            this.datum = clone(data[0])

            if (!this.datum.condition) {
              this.datum.condition = null
            }
            if (!this.datum.score) {
              this.datum.score = null
            }
          }
        }).catch((err) => {
          console.log(err)
        })
      }

      this.condition = getCondition(this.datum.condition)
      this.score = this.datum.score

      if (this.score) {
        this.points = {
          volume: this.valueToPoint(this.score.volume && this.score.volume.score ? this.score.volume.score : 0, 0),
          quality: this.valueToPoint(this.score.quality && this.score.quality.score ? this.score.quality.score : 0, 2),
          speed: this.valueToPoint(this.score.speed && this.score.speed.score ? this.score.speed.score : 0, 1)
        }
      }

      this.$forceUpdate()

      this.$refs.header.checkCondition()

      this.mask = false
    }
  }
}
</script>

<style scoped lang="stylus">
.page
  .body
    .tabs
      height 3.375rem
      border-bottom 1px solid #e6e8f1
      >>> .nav
        overflow-x scroll
        // overflow-x hidden
        -ms-overflow-style none
        flex-wrap nowrap
        white-space nowrap
        .nav-item
          .nav-link
            height calc(3.375rem - 1px)
            line-height 2.375rem
            border-radius 0
            padding 0.5rem 2rem

            background-color #fafafa
            color #444
            border-right 1px solid #e6e8f1

            &.active
              background-color #fff
              color #222
              font-weight 600
          &:first-child
            width 16rem
            text-align center
    .left
      min-height calc(100vh - 3.75rem - 5.5rem - 6.75rem)
      .condition
        min-height 10rem

        color #fff
        background-color #ccc

        .icon.far.fa-triangle
          &:before
            content '△'

        &.excellent
          background linear-gradient(0.25turn, #e0ac9e, #d9638b)
        &.verygood
          background linear-gradient(0.25turn, #e0ac9e, #d9638b)
        &.good
          background linear-gradient(0.25turn, #e0ac9e, #d9638b)
        &.bad
          background-color #555884
        &.verybad
          background-color #555884
        &.clear
          background linear-gradient(0.25turn, #d7528b, #5f429d)
        &.finish
          background-color #555884

        .description
          font-size 0.75rem
          margin-left 1rem
          margin-right 1rem
      h4
        color #ccc
        font-weight 600
        font-size 1rem
        i.icon
          text-align center
          width 2rem
          height 2rem
          border-radius 1rem
          background-color #999
          font-size 1rem
          line-height 2rem
          color #fff

      .sticky
        i.icon
          text-align center
          width 1rem
          height 1rem
          border-radius .5rem
          background-color #999
          font-size .5rem
          line-height 1rem
          color #fff

      .volume h4
        color #da748e
      .quality h4
        color #e8a927
      .speed h4
        color #759dae

      .volume i.icon
        background-color #da748e
      .quality i.icon
        background-color #e8a927
      .speed i.icon
        background-color #759dae

      .score
        color #999
      .volume .score
        color #da748e
      .quality .score
        color #e8a927
      .speed .score
        color #759dae

      .list-group
        .list-group-item
          .badge
            font-size 0.5rem
            padding 0.25rem 0.2125rem
            background-color #fff
            border 1px solid #ccc
            color #999

      .clickable
        cursor pointer
    .right
      min-height calc(100vh - 3.75rem - 5.5rem - 6.75rem)
      position relative
      h2
        margin 0
        padding 0 1.875rem
        height: 5.5rem;
        border-bottom 1px solid #e6e8f1
        color #999
        font-size 1.5rem
        font-weight 600
        line-height 3rem
        i.icon
          text-align center
          width 3rem
          height 3rem
          border-radius 1.5rem
          background-color #999
          /* font-size 1.5rem*/
          line-height 3rem
          color #fff
        .sticky
          .caption
            font-size 0.75rem
            color #999
          .score
            font-size 2rem
        &.volume
          color #da748e
          i.icon
            background-color #da748e
        &.quality
          color #e8a927
          i.icon
            background-color #e8a927
        &.speed
          color #759dae
          i.icon
            background-color #759dae

      .chart
        width 80%
        margin-left calc(20% / 2)
        .wrapper
          position relative
          margin-top 6rem
          margin-left auto
          margin-right auto
          max-width 60%
          &:before
            content ''
            display block
            padding-top 100%
          svg
            position absolute
            width 100%
            height 100%
            top 0
            left 0
            bottom 0
            right 0
            circle
              fill transparent
              stroke-width 0.5px
              stroke #ccc
            .circle0
              fill #fff
            circle.values
              stroke-width 3px
            circle.volume
              stroke #da748e
            circle.quality
              stroke #e8a927
            circle.speed
              stroke #759dae
            line
              stroke-width 0.5px
              stroke #ccc
            polygon
              fill transparent
              stroke-width 7px
              stroke #7ea2c7
          i.icon
            display block
            position absolute
            text-align center
            width 2.5rem
            height 2.5rem
            border-radius 1.25rem
            background-color #999
            /* font-size 1.5rem*/
            line-height 2.5rem
            color #fff
            &.volume
              top -4.5rem
              left calc(50% - 1.25rem)
              background-color #da748e
            &.quality
              bottom 13.5%
              left -2rem
              background-color #e8a927
            &.speed
              bottom 13.5%
              right -2rem
              background-color #759dae
          .value
            display block
            position absolute
            font-size 1rem
            &.volume
              top -4.5rem
              left calc(50% - 1.25rem)
              transform translate(0.55rem, 2.75rem)
              color #da748e
            &.quality
              bottom 13.5%
              left -2rem
              transform translate(0.55rem, 1.5rem)
              color #e8a927
            &.speed
              bottom 13.5%
              right -2rem
              transform translate(-0.55rem, 1.5rem)
              color #759dae
      .alert.calculating
        position absolute
        width 22rem
        text-align center
      .legends
        font-size 1rem
        color #999
        .caption
          &:before
            content "\f111"
            font-family "Font Awesome 5 Free"
            font-weight 900
            padding-right 0.5rem
        .volume .caption:before
          color #da748e
        .quality .caption:before
          color #e8a927
        .speed .caption:before
          color #759dae
      .card
        .badge
          vertical-align middle
          background-color #fff
          border 1px solid #ccc
          color #999
          font-weight 600
          padding .375rem .5rem
        .values
          line-height 2rem
          vertical-align middle
          .precentage
            min-width 5rem
            text-align right
</style>

<style lang="stylus">
.main.wide
  .page.dashboard
    .alert.calculating
      position absolute
      top calc((100vw - 5rem - 16rem) * .75 / 2 - 3rem)
      margin-left calc(((100vw - 5rem - 16rem) - 22rem) / 2 - 25px)
.main.narrow
  .page.dashboard
    .alert.calculating
      position absolute
      top calc((100vw - 15rem - 16rem) * .75 / 2 - 3rem)
      margin-left calc(((100vw - 15rem - 16rem) - 22rem) / 2 - 25px)
</style>
